module.exports = __webpack_public_path__ + "static/media/PartnersBgIcon.c1fb431b.svg";